export default __webpack_public_path__ + "static/media/screencaptureTogglTrack20210414113046.9e041bf3.png";